//tslint:disable:export-name
export { SubscriptionsService } from './service-setup/SubscriptionsService';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.subscriptionsService).register();

setupServiceInfo(__serviceInfo__);
